<template>
    <div>
        <footer>
            <!-- <div>
                抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活
            </div>
            <div>
                适龄提示：适合8岁（含）以上玩家娱乐 Copyright@2023-2025 LebiGames all rights reserved
            </div>
            <div>
                审批文号：国新出审(2024〕2397号出版物号:ISBN 978-7-498-14270-2
            </div> -->
            <div>
                <a :href="privacyPolicyUrl" target="_blank">Privacy Policy</a> 
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;｜&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <a :href="termsOfServiceUrl" target="_blank">Terms&Conditions</a>
            </div>
            <div class="bottomText">
                ©️2026 HABBY.FUN
                <!-- <a style="color:#6b6969;font-size:1.4rem " href="https://beian.miit.gov.cn/#/home" target="_blank">©2026 Engage Games</a> -->
            </div>

        </footer>
    </div>
</template>

<script>
// 与 guide/logic.js、tga.js 一致：正式域名用 prod，其余（含 test / 本地）走测试域名
const PROD_HOSTS = ['piroker.com', 'www.piroker.com']

function getSiteOrigin() {
  const host = (window.location.hostname || '').toLowerCase()
  const isProd = PROD_HOSTS.includes(host)
  return isProd ? 'https://www.piroker.com' : 'https://www.test.piroker.com'
}

export default {
  name: 'AppFooter',
  computed: {
    privacyPolicyUrl() {
      return `${getSiteOrigin()}/privacyPolicy.html`
    },
    termsOfServiceUrl() {
      return `${getSiteOrigin()}/termsOfService.html`
    },
  },
}
</script>

<style lang="less" scoped>
footer {
    position: relative;
    padding: 71px 0 40px;
    color: #FFF;
    font-size: 1.8rem;
    font-weight: 900;
    min-width: 1500px;
    background: url('../../static/pc/di.png') center center no-repeat !important;
    background-size: 100% 100% !important;
    a {
        color: #FFF;
    }
    div {
        margin-top: 1.875rem;
    }
    p {
        display: none;
    }
    .bottomText {
        color:#6b6969;
        font-size:1.4rem;
    }
}
@media screen and (max-width: 1024px) {
    footer {
        height: h(425);
        padding: px(80) px(70) px(60);
        background: url('../../static/mo/di.png') center center no-repeat !important;
        background-size: 100% 100% !important;
        div {
            margin-top: 0;
            display: flex;
            flex-direction: column;
            align-items: start;
            font-size: px(42);
            gap: px(32);
            span {
                display: none;
            }
        }
        p {
            display: block;
            height: px(20);
        }
        .bottomText {
            margin-top: px(80);
            font-size: px(30);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue